import { useInfiniteQuery } from 'react-query';
import { getAllActivityService } from '../redux/services/activityService';
import HookTypes from '../redux/types/hooks';
import { PaginatedActivityResponse } from '../types/activity';

const fetchProjects = async ({ pageParam = 0 }) => {
  const res = await getAllActivityService(pageParam);
  return res;
};

const useHook = () => {
  return useInfiniteQuery<PaginatedActivityResponse>({
    queryKey: [HookTypes.activity],
    queryFn: fetchProjects,
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.hasNext) {
        const nextPage = lastPage.page + 1;
        return nextPage;
      }
      return undefined;
    },
  });
};

export default useHook;
